import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import OrderInfoDetail from '../../domain/order-info.interface';

@Component({
  selector: 'app-order-details-box',
  templateUrl: './order-details-box.component.html',
  standalone: true,
  imports: [MatIconModule, DatePipe],
})
export class OrderDetailsBoxComponent implements OnInit {
  @Input() title: string;
  @Input() data: OrderInfoDetail[];

  constructor() {}

  ngOnInit(): void {}
}
